import { render } from "./NewMessage.vue?vue&type=template&id=4491deee&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"

import "./NewMessage.vue?vue&type=style&index=0&id=4491deee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4491deee"]])

export default __exports__